import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/plus.svg";
var PlusSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  PlusSolid_default as default
};
